module.exports = __webpack_public_path__ + "static/media/visa-logo.6f29c863.png";